import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import {urls} from '@/constants/urls'
import {CookiesLinksProps} from './props'
import styles from './styles.scss'

export const CookiesLinks: React.FC<CookiesLinksProps> = ({className}) => {
    const { t } = useTranslation()
    return <div className={classNames(styles.links, className)}>
        <a href={urls.cookiePolicy} target={'_blank'} rel="noreferrer">{t('CookiesLinks.cookiesPolicy')}</a>
        <a href={urls.privacyPolicy} target={'_blank'} rel="noreferrer">{t('CookiesLinks.privacyPolicy')}</a>
        <a href={urls.termsUse} target={'_blank'} rel="noreferrer">{t('CookiesLinks.termsAndConditions')}</a>
    </div>
}
